import { Box } from '@mui/material';
import { useRouter } from 'next/router';

import ContentTab, { type ContentTabItem } from '@/components/ContentTab';
import useApproval from '@/components/Approval/@hooks/useApproval';
import { useGetNewTalkFlowList } from '@/hooks/apiHooks';
import { INIT_TALK_FLOW_COUNT_PARAMS } from '@/recoil/init_data';
import { DocumentTitle } from '@/components/Approval/Content/DocumentContents';
import { WORK_APPROVAL_TAB, WORK_MEETING_NOTES_TAB } from '@/constant/url';

type P = {
  isDocument: boolean;
};

type SubTab = 'approval' | 'document';

/** 어느 탭이냐에 따라 URL 의 `subtab` 만 갈아끼운다 — 화면 상태는 URL 이 갖는다 */
const SUBTAB_QUERY: Record<SubTab, string> = {
  approval: WORK_APPROVAL_TAB,
  document: WORK_MEETING_NOTES_TAB,
};

const TabSwitch = ({ isDocument }: P) => {
  const router = useRouter();
  const { doApprovalData } = useApproval();
  const { data } = useGetNewTalkFlowList(INIT_TALK_FLOW_COUNT_PARAMS);
  const doApprovalCount =
    doApprovalData?.meta.totalCount && doApprovalData?.meta.totalCount > 0
      ? doApprovalData?.meta.totalCount
      : undefined;

  const documentCount =
    data?.meta.totalCount && data?.meta.totalCount > 0
      ? data?.meta.totalCount
      : undefined;

  const items: ContentTabItem<SubTab>[] = [
    { value: 'approval', title: 'Approval', count: doApprovalCount },
    { value: 'document', title: DocumentTitle, count: documentCount },
  ];

  const handleChange = (value: SubTab) => {
    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, tab: 'work', subtab: SUBTAB_QUERY[value] },
      },
      undefined,
      { shallow: true },
    );
  };

  return (
    // 폭은 내용만큼(기존 `width: fit-content`), 위 여백 24 는 이 컴포넌트가 갖고 있던 값이다
    <Box sx={{ mt: 3, width: 'fit-content' }}>
      <ContentTab
        items={items}
        value={isDocument ? 'document' : 'approval'}
        onChange={handleChange}
        // 옛 구현의 13.33px(크롬 버튼 기본값)에 가장 가까운 프리셋
        size="regular"
      />
    </Box>
  );
};

export default TabSwitch;
